import { useState } from "react";
import { toast } from "sonner";
import { Share2, Loader2 } from "lucide-react";
import { downloadFile } from "@/lib/api";
import { usePaywall } from "@/context/PaywallContext";

export const SocialKitButton = ({ jobId, filename }) => {
  const [busy, setBusy] = useState(false);
  const paywall = usePaywall();

  const onClick = async () => {
    setBusy(true);
    try {
      const stem = filename.replace(/\.[^.]+$/, "");
      await downloadFile(`/api/jobs/${jobId}/social-kit`, `${stem}_social_kit.zip`);
      toast.success("Social kit ready · profiles, banners & favicons");
    } catch (err) {
      if (err.status === 402) return paywall.open({ job_id: jobId, name: filename });
      toast.error(err.message || "Social kit failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid="download-social-kit-btn"
      className="inline-flex items-center gap-2 rounded-none border border-[#0A0A0B] bg-white hover:bg-[#0A0A0B] hover:text-white text-[#0A0A0B] text-xs uppercase tracking-[0.2em] font-bold h-12 px-6 transition-colors duration-200 cursor-pointer disabled:opacity-60 disabled:cursor-wait"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Share2 className="w-4 h-4" />}
      {busy ? "Building kit…" : "Social kit (.zip)"}
    </button>
  );
};
